import { render, staticRenderFns } from "./invitation-button.component.vue?vue&type=template&id=7d578ea2&scoped=true"
import script from "./invitation-button.component.vue?vue&type=script&lang=js"
export * from "./invitation-button.component.vue?vue&type=script&lang=js"
import style0 from "./invitation-button.component.vue?vue&type=style&index=0&id=7d578ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d578ea2",
  null
  
)

export default component.exports